import { HELP_CATEGORIES } from '@hoopoe/shared';
import { createFileRoute, Link } from '@tanstack/react-router';
import { GettingStartedChecklist } from '../components/help/checklist';
import { articlesFor } from '../lib/help/articles';
import { useCustomArticles } from '../lib/help/custom';
import { useRole } from '../lib/session';

export const Route = createFileRoute('/onboarding/')({ component: OnboardingHome });

function OnboardingHome() {
  const articles = articlesFor(useRole(), useCustomArticles());
  return (
    <div className="max-w-3xl space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Onboarding</h1>
        <p className="mt-1 text-sm text-muted-foreground">How Hoopoe works, how to do things, and what every term means.</p>
      </header>
      <GettingStartedChecklist />
      <div className="grid gap-3 sm:grid-cols-2">
        {HELP_CATEGORIES.map(c => {
          const list = articles.filter(a => a.category === c.key);
          if (!list.length) return null;
          return (
            <section key={c.key} className="rounded-lg border bg-surface p-4" aria-labelledby={`cat-${c.key}`}>
              <h2 id={`cat-${c.key}`} className="mb-2 font-semibold">
                {c.label}
              </h2>
              <ul className="space-y-1 text-sm">
                {list.map(a => (
                  <li key={a.slug}>
                    <Link to="/onboarding/$slug" params={{ slug: a.slug }} className="underline-offset-2 hover:underline">
                      {a.title}
                    </Link>
                    {a.summary && <span className="block text-xs text-muted-foreground">{a.summary}</span>}
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    </div>
  );
}
